module.exports = __webpack_public_path__ + "static/media/mt-ut-img-3-3.42c8c9c6.jpg";